export const LANGUAGE_CONFIG = {
  app: 'Giros Nacionales',
  menu: {
    accessControl: 'Control de acceso',
    accounting: 'Contabilidad',
    reports: 'Reportes',
    accountingGroups: 'Grupos contables',
    accountingEvents: 'Eventos contables',
    amlLimits: 'Antilavado',
    balanceInterface: 'Interfaz de saldos',
    channels: 'Canales',
    commissions: 'Comisiones',
    constants: 'Constantes',
    customersFilter: 'Consultar cliente',
    eventCodes: 'Códigos de eventos',
    generalParameters: 'Parámetros Generales',
    home: 'Inicio',
    limits: 'Topes',
    logs: 'Logs',
    masterTransfers: 'Maestro de giros',
    movementInterface: 'Interfaz de movimientos',
    paymentMethods: 'Medios de pago',
    roles: 'Roles',
    rules: 'Reglas',
    segments: 'Segmentos',
    status: 'Estados de canales',
    templates: 'Plantillas',
    transactionalEvents: 'Eventos transacionales',
    transactionsEvents: 'Transacciones y eventos',
    transfers: 'Giros',
    transfersCustomer: 'Giros por cliente',
    transfersReference: 'Giro por referencia',
    users: 'Usuarios',
    logReport: 'Log de Modificaciones',
    totalCosts: 'Costos Totales'
  },
  button: {
    accept: 'Aceptar',
    add: 'Agregar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    collapse: 'Colapsar',
    delete: 'Eliminar',
    detail: 'Detalle',
    disable: 'Anular',
    reverse: 'Reverso',
    download: 'Descargar',
    edit: 'Editar',
    editId: 'Editar Documento',
    editTel: 'Editar telefono',
    expand: 'Expandir',
    export: 'Exportar',
    list: 'Listar',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    next: 'Continuar',
    search: 'Consultar',
    send: 'Enviar',
    viewDetail: 'Ver detalle'
  },
  input: {
    search: 'Buscar'
  },
  select: {
    select: 'Seleccione una opción'
  },
  paginator: {
    itemsPerPage: 'Elementos por página',
    nextPage: 'Siguiente página',
    previousPage: 'Anterior página',
    lastPage: 'Ultima página',
    firstPage: 'Primera página'
  },
  message: {
    accumulated: 'Acumulado',
    addSuccess: 'Elemento agregado exitosamente',
    aggregate: 'agregado',
    all: 'todos',
    annual: 'Anual',
    available: 'Disponible',
    textSession: 'Su sesión finalizará en {SECOND} segundos',
    cancelTransfer: 'El giro con referencia única {REFERENCE} fue anulado',
    reverseTransfer: 'El giro con referencia única {REFERENCE} fue reversado',
    cancellationDetail: 'Detalle de cancelación',
    customerInfo: 'Información del cliente',
    customersInfo: 'Información de los clientes',
    delete: 'Eliminar',
    deleteAll: 'Todos los elementos fueron eliminados',
    deleted: 'eliminado',
    deletedAll: 'Eliminar todos',
    deleteElements: ' elementos fueron eliminados',
    deletedElements: 'Eliminar ({COUNT})',
    deleteOne: '1 elemento fue eliminado',
    deleteRol: 'El rol {ROL_NAME} fue eliminado',
    editSuccess: 'Elemento modificado exitosamente',
    element: 'Elemento',
    elements: 'elementos',
    error: 'Error',
    errorFatal: 'Ha ocurrido un problema, por favor vuelve a intentar',
    ohErrorFatal: 'Houston! Tenemos un problema',
    ohNoElements: 'Oh cielos! No encontramos elementos',
    ohNoElementsFilter:
      'Lastima! No hemos encontrado objetos con estos criterios',
    invalidNumber: 'El campo solo acepta números',
    invalidPercent: 'El formato del número es incorrecto',
    invalidSpaces: 'El campo no acepta espacios',
    invalidText: 'El campo solo acepta letras',
    loading: 'Cargando...',
    modified: 'modificado',
    monthly: 'Mensual',
    noLogin: `Ha ocurrido un error al tratar de consumir el recurso, por favor vuelva a intentarlo.
              Si el problema persiste, por favor contacte al administrador.`,
    noDelete: 'El elemento no se eliminó',
    noDeleted: 'No se lograron eliminar los siguientes elementos:',
    noEdit: 'El elemento no se modificó',
    noElements: 'No hay elementos a mostrar',
    primary: 'Principal',
    required: 'Requerido',
    second: 'Secundarias',
    success: 'exitosamente',
    succesed: 'Exitoso',
    transfersInfo: 'Información de los giros',
    total: 'Total',
    unlimited: 'Ilimitado'
  },
  question: {
    cancelTransfer: '¿Está seguro que desea anular el giro con referencia única {REFERENCE}?',
    reverseTransfer: '¿Está seguro que desea reversar el giro con referencia única {REFERENCE}?',
    deleteAll: '¿Desea eliminar todos los elementos?',
    deleteElementsEnd: ' elementos?',
    deleteElementsStart: '¿Desea eliminar ',
    deleteOne: '¿Desea eliminar 1 elemento?',
    edit: '¿Desea modificar el elemento?'
  },
  title: {
    add: 'Agregar',
    edit: 'Modificar',
    detail: 'Detalle de',
    searchCustomer: 'Búsqueda de cliente',
    searchTransfersReference: 'Búsqueda de giro por referencia'
  },
  accounting: {
    event: 'Evento',
    reference: 'Referencia'
  },
  accountingEvents: {
    id: 'Id',
    name: 'Evento contable',
    title: 'evento contable',
    titles: 'Eventos contables'
  },
  accountingGroups: {
    id: 'Id',
    name: 'Grupo contable',
    title: 'grupo contable',
    titles: 'Grupos contables'
  },
  amlLimits: {
    annualCount: 'Giros anuales',
    annualValue: 'Monto anual',
    count: 'Número de Giros',
    greaterAnnualCount:
      'Los Giros Mensuales deben ser menores a los Giros Anuales',
    greaterAnnualValue: 'El Monto Mensual debe ser menor al Monto Anual',
    id: 'Id',
    monthlyCount: 'Giros mensuales',
    monthlyValue: 'Monto mensual',
    name: 'Tope antilavado',
    noSegments: 'No existen segmentos para asignar nuevos topes',
    title: 'tope antilavado',
    titles: 'Topes antilavado',
    unlimited: '9999 corresponde a ilimitado',
    value: 'Valor del Monto'
  },
  channels: {
    existsChannelId: 'Ya existe un canal con dicho id',
    existsChannelName: 'Ya existe un canal con dicho nombre',
    id: 'Id',
    name: 'Canal',
    noChannelId: 'No existe un canal con este id',
    noChannelName: 'No existe un canal con este nombre',
    title: 'canal',
    titles: 'Canales'
  },
  commissions: {
    endValue: 'Rango máximo',
    fixValue: 'Comisión fija',
    greaterStartEnd: 'El Rango Mínimo debe ser menor al Rango Máximo',
    id: 'Id',
    name: 'Comisión',
    noChannels: 'No existen canales para asignar nuevas comisiones',
    noCommissionChannel: 'No existen comisiones con el nombre de dicho canal',
    startValue: 'Rango mínimo',
    titles: 'Comisiones',
    title: 'comisión',
    variableValue: 'Comisión variable'
  },
  constants: {
    id: 'Id',
    name: 'Constante',
    description: 'Descripción',
    title: 'constante',
    titles: 'Constantes',
    value: 'Valor'
  },
  customers: {
    accumulatedMonthlyCount: 'Acumulado de giros mensuales',
    accumulatedMonthlyValue: 'Acumulado de monto mensual',
    accumulatedAnnualCount: 'Acumulado de giros anuales',
    accumulatedAnnualValue: 'Acumulado de monto anual',
    cell: 'Número de celular',
    updateCell: 'Celular',
    cellNew: 'Número de celular nuevo',
    cellOld: 'Número de celular anterior',
    dead: 'Se encuentra fallecido',
    details: 'Detalle de cliente',
    identify: 'Número de identificación',
    updateIdentify: 'Número de documento',
    identifyOld: 'Número de identificación anterior',
    identifyNew: 'Número de identificación nuevo',
    name: 'Cliente',
    nameCustomer: 'Nombre del cliente',
    noCustomer: 'No existe un cliente con estos datos',
    otherName: 'Nombre',
    title: 'cliente',
    titles: 'Clientes',
    update: '¿Qué desea modificar?'
  },
  eventCode: {
    activity: 'Actividad',
    code: 'Código del evento',
    channel: 'Canal',
    id: 'Id',
    nature: 'Naturaleza del evento',
    transaction: 'Transacción',
    title: 'Códigos de Eventos'
  },
  login: {
    userIncorrect: 'Usuario y/o contraseña no valido',
    titleAccessDenied: 'Acceso denegado',
    accessDenied: 'Actualmente su usuario no tiene permisos para acceder a esta página',
    textLogin1: 'Ahora los',
    textLogin2: 'GIROS',
    textLogin3: 'SON PARA TODOS',
    user: 'Usuario'
  },
  paymentMethods: {
    id: 'Id',
    name: 'Medio de pago',
    title: 'medio de pago',
    titles: 'Medios de pago'
  },
  roles: {
    id: 'Id',
    name: 'Rol',
    title: 'rol',
    titles: 'Roles',
    noRoles: 'No existen roles para asignar nuevos usuarios',
    confirmDelete: '¿Desea eliminar el rol {ROL_NAME}?',
    noRelEdit: 'No existe un rol con esta información',
    description: 'Descripción'
  },
  rules: {
    id: 'Id',
    idRule: 'Id Regla',
    name: 'Regla',
    title: 'regla',
    titles: 'Reglas'
  },
  segments: {
    id: 'Id',
    idSegment: 'Id Segmento',
    noSegmentId: 'No existe un segmento con este id',
    name: 'Segmento',
    segmentName: 'Ya existe un segmento con dicho nombre',
    title: 'segmento',
    titles: 'Segmentos'
  },
  status: {
    id: 'Id',
    name: 'Estado de canal',
    otherName: 'Estado',
    statusName: 'Ya existe un estado con dicho nombre',
    title: 'estado de canal',
    titles: 'Estados de canales'
  },
  templates: {
    id: 'Id',
    name: 'Plantilla',
    title: 'plantilla',
    titles: 'Plantillas',
    value: 'Valor',
    idType: 'Id Tipo',
    type: 'Tipo'
  },
  transactionalEvents: {
    id: 'Id',
    name: 'Evento transaccional',
    title: 'evento transaccional',
    titles: 'Eventos transaccionales'
  },
  transfers: {
    afterMinimum: 'La fecha no cumple con el formato',
    accountant: 'Contable',
    beneficiary: 'Beneficiario',
    correspondentUser: 'Corresponsal/Usuario',
    interface: 'Interfaz',
    detail: 'Ver detalle',
    details: 'Detalle del giro',
    date: 'Fecha',
    dateEnd: 'Fecha final',
    dateSend: 'Fecha de envío',
    dateStart: 'Fecha inicial',
    editCell:
      '¿Desea modificar el celular del {CUSTOMER}? El nuevo dato será {CELL}',
    editIdentify:
      '¿Está seguro que desea modificar el número de documento del {CUSTOMER}? El nuevo dato será {IDENTIFY}',
    format: 'Formato',
    greaterStartEnd: 'La fecha final debe ser mayor o igual a la fecha inicial',
    hour: 'Hora',
    identify: 'Identificación del ',
    invalidCell: 'El celular debe comenzar por 3 y poseer 10 números',
    invalidDate: 'El formato de fecha es invalido',
    iva: 'IVA',
    listTransfers: 'Detalle de giros por cliente',
    betweenToday:
      'La fecha debe estar en el rango de 90 días hacia atras desde hoy',
    betweenYesterday:
      'La fecha debe estar en el rango de 90 días hacia atras desde ayer',
    minorToday: 'La fecha debe ser menor o igual a hoy',
    name: 'Nombre del ',
    noTransfers: 'No existe un giro con esta referencia',
    office: 'Oficina',
    owner: 'Girador',
    rol: 'Rol',
    reference: 'Referencia del giro',
    status: 'Estado del giro',
    txt: 'TXT',
    title: 'giro',
    titleBeneficiary: 'Datos del beneficiario',
    titleCancel: 'Datos de cancelación',
    titleOwner: 'Datos del girador',
    titlePay: 'Datos de pago',
    titleStatus: 'Datos del último estado',
    titleSend: 'Datos de envío',
    typeDate: 'Tipo de fecha',
    value: 'Monto del giro',
    xls: 'XLS'
  },
  typeIdentify: {
    name: 'Tipo de identificación'
  },
  users: {
    id: 'Id',
    name: 'Usuario',
    title: 'usuario'
  },
  validDate: {
    copareDates: 'La fecha de inicio debe ser inferior a la fecha final',
    dateEndEmpty: 'La fecha de fin se encuentra vacía',
    dateStartEmpty: 'La fecha de inicio se encuentra vacía'
  }
};
